import React, { useState } from "react";
import "../../assets/styles/order3.css";
import { motion } from "framer-motion";
import Vector2 from "../../assets/images/vect1.png";
import vect2 from "../../assets/images/vect2.png";
import vect3 from "../../assets/images/Vector3.png";

const Order3 = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, phone, company, message } = formData;

    if (!name || !email || !phone || !company || !message) {
      alert("Please fill out all fields.");
      return;
    }

    const recipientEmail = "sales@commceed.com";
    const subject = "New Contact Form Submission";
    const body = `Hello,\n\nName: ${name}\nEmail: ${email}\nPhone: ${phone}\nCompany: ${company}\nMessage:\n${message}}`;

    window.location.href = `mailto:${recipientEmail}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    setFormData({
      name: "",
      email: "",
      phone: "",
      company: "",
      message: "",
      sendInfo: true,
      geolocationConsent: false,
    });
  };
  return (
    <div className="order3-container">
      {/* Top Section (White Background) */}
      <motion.div
        className="top-section"
        initial={{ opacity: 0, y: 50 }} // Start slightly below for smoother transition
        whileInView={{ opacity: 1, y: 0 }} // Slide to original position
        viewport={{ once: true }}
        transition={{ duration: 1.5, ease: "easeInOut" }} // Slower and smoother transition
      >
        <motion.img
          src={vect3}
          alt="Vector 3"
          className="vector3"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
        />
        <motion.h1
          className="order3-heading"
          initial={{ opacity: 0, y: 20 }} // Start with opacity 0 and slightly below
          whileInView={{ opacity: 1, y: 0 }} // Fade in and slide to position
          transition={{ duration: 1.5, ease: "easeInOut" }}
        >
          STAY CONNECTED, STAY AHEAD WITH commceed
        </motion.h1>
        <motion.p
          className="order3-paragraph"
          initial={{ opacity: 0, y: 20 }} // Start with opacity 0 and slightly below
          whileInView={{ opacity: 1, y: 0 }} // Fade in and slide to position
          transition={{ duration: 1.5, ease: "easeInOut" }}
        >
          Reach us on
        </motion.p>
        <motion.div className="contact-info">
          <motion.p className="order3-paragraph">
            <span className="label">Email&nbsp;</span>{" "}
            <span className="value">: sales@commceed.com</span>
          </motion.p>
          {/* <motion.p className="order3-paragraph">
            <span className="label">Office</span>{" "}
            <span className="value">: +61 3 8564 8530</span>
          </motion.p>
          <motion.p className="order3-paragraph">
            <span className="label">Sales</span>{" "}
            <span className="value">: +61 478 97 6061</span>
          </motion.p>
          <motion.p className="order3-paragraph">
            <span className="label">WhatsApp</span>{" "}
            <span className="value">: +61 478 97 6061</span>
          </motion.p> */}
        </motion.div>
      </motion.div>

      {/* Bottom Section (Black Background) */}
      <motion.div
        className="bottom-section"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1.5, ease: "easeInOut" }}
      >
        {/* <motion.img 
          src={Vector2} 
          alt="Vector 1" 
          className="vector1"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}  // Slide from the left
          transition={{ duration: 1.5, ease: "easeInOut" }}
        />
        <motion.img 
          src={vect2} 
          alt="Vector 2" 
          className="vector2"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}  // Slide from the right
          transition={{ duration: 1.5, ease: "easeInOut" }}
        /> */}

        <motion.form
          onSubmit={handleSubmit}
          className="text-white p-20 rounded-lg w-full"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-4 w-full">
            <div>
              <input
                name="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                placeholder="Name"
                className="w-full p-3 bg-gray-800 text-white placeholder-gray-400  outline-none focus:ring-2 focus:ring-lime-500"
                required
              />
            </div>
            <div>
              <input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
                className="w-full p-3 bg-gray-800 text-white placeholder-gray-400  outline-none focus:ring-2 focus:ring-lime-500"
                required
              />
            </div>
            <div>
              <input
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Phone"
                className="w-full p-3 bg-gray-800 text-white placeholder-gray-400  outline-none focus:ring-2 focus:ring-lime-500"
                required
              />
            </div>
            <div>
              <input
                name="company"
                type="text"
                value={formData.company}
                onChange={handleChange}
                placeholder="Company"
                className="w-full p-3 bg-gray-800 text-white placeholder-gray-400  outline-none focus:ring-2 focus:ring-lime-500"
                required
              />
            </div>
          </div>

          <div className="mb-4 w-full">
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows={4}
              placeholder="Message"
              className="w-full p-3 bg-gray-800 text-white placeholder-gray-400  outline-none focus:ring-2 focus:ring-lime-500"
              required
            />
          </div>

          <div className="w-full text-right">
            <button type="submit" className="subscribe-button">
              Send message →
            </button>
          </div>
        </motion.form>
      </motion.div>
    </div>
  );
};

export default Order3;
